import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import "./SectionDigitalMarketingNew.css";
import "../../../GalleryShared.css";

/* ── PLACEHOLDER IMAGES — swap these out later ── */
import dm_ettmt01      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt01.webp";
import dm_ettmt02      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt02.webp";
import dm_ettmt03      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt03.webp";
import dm_ettmt04      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt04.webp";
import dm_ettmt05      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt05.webp";
import dm_ettmt06      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt06.webp";
import dm_ettmt07      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt07.webp";
import dm_ettmt08      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_ettmt08.webp";
import dm_vasuki01      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_vasuki01.webp";
import dm_vasuki02      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_vasuki02.webp";
import dm_vasuki03      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_vasuki03.webp";
import dm_vasuki04      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/dm_vasuki04.webp";
import YoBykes01      from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/YoBykes 1.webp";
import YoBykes02       from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/YoBykes 2.webp";
import YoBykes03       from "../../../../../Assets/Images/gallary/digital marketing/manufacturing/YoBykes 3.webp";
import dm_omkara01       from "../../../../../Assets/Images/gallary/digital marketing/real estate/dm_omkara01.webp";
import dm_omkara02       from "../../../../../Assets/Images/gallary/digital marketing/real estate/dm_omkara02.webp";

/* ── SLIDES — replace images/industries/sub later ── */
const ALL_SLIDES_SM = [
  { left: [dm_ettmt02, dm_ettmt01, dm_ettmt03, dm_ettmt04, dm_ettmt05, dm_ettmt06, dm_ettmt07, dm_ettmt08],                     behind: [], thumb: dm_ettmt01,    industry: "Manufaturing", sub: "Social Media Post" },
  { left: [dm_vasuki03, dm_vasuki02, dm_vasuki01, dm_vasuki04],            behind: [], thumb: dm_vasuki03, industry: "Manufaturing", sub: "Social Media Post" },
   { left: [YoBykes01, YoBykes02, YoBykes03],            behind: [], thumb: YoBykes01, industry: "Manufaturing", sub: "Social Media Post" },
   { left: [dm_omkara01, dm_omkara02],            behind: [], thumb: dm_omkara01, industry: "Real Estate", sub: "Social Media Post" },
];

const INDUSTRIES_SM = ["Manufaturing", "Real Estate"];

/* ── Helpers ── */
const SM_IMAGE_EXTS = [".png", ".jpg", ".jpeg", ".webp", ".gif", ".avif", ".svg"];

function isImageSrcSM(src) {
  if (!src) return false;
  return SM_IMAGE_EXTS.some((ext) => src.toLowerCase().endsWith(ext));
}

/* ══════════════════════════════════════════════
   VIDEO / IMAGE PLAYER  (prefix: sm-)
══════════════════════════════════════════════ */
function VideoPlayerSM({ src, thumb, videoRef: externalRef }) {
  const internalRef = useRef(null);
  const videoRef    = externalRef ?? internalRef;
  const progressRef = useRef(null);
  const wrapRef     = useRef(null);
  const hideTimer   = useRef(null);

  const [playing,   setPlaying]   = useState(false);
  const [progress,  setProgress]  = useState(0);
  const [duration,  setDuration]  = useState(0);
  const [showCtrl,  setShowCtrl]  = useState(false);
  const [isFS,      setIsFS]      = useState(false);
  const [showThumb, setShowThumb] = useState(true);
  const [muted,     setMuted]     = useState(true);
  const [volume,    setVolume]    = useState(1);

  const isImage = isImageSrcSM(src);

  useEffect(() => {
    setShowThumb(true);
    setPlaying(false);
    setProgress(0);
    setDuration(0);
  }, [src]);

  useEffect(() => () => clearTimeout(hideTimer.current), []);

  useEffect(() => {
    const onChange = () => setIsFS(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const fmt = (s) => {
    if (!s || isNaN(s)) return "0:00";
    return `${Math.floor(s / 60)}:${Math.floor(s % 60).toString().padStart(2, "0")}`;
  };

  const togglePlay = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const v = videoRef.current; if (!v) return;
    v.paused ? v.play().catch(() => {}) : v.pause();
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    setMuted((prev) => {
      if (videoRef.current) videoRef.current.muted = !prev;
      return !prev;
    });
  };

  const handleVolume = (e) => {
    e.stopPropagation();
    const val = parseFloat(e.target.value);
    setVolume(val);
    if (videoRef.current) {
      videoRef.current.volume = val;
      videoRef.current.muted  = val === 0;
    }
    setMuted(val === 0);
  };

  const toggleFS = (e) => {
    e.stopPropagation();
    if (!document.fullscreenElement) wrapRef.current?.requestFullscreen().catch(() => {});
    else document.exitFullscreen();
  };

  const handleSeek = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const bar = progressRef.current; const v = videoRef.current;
    if (!bar || !v) return;
    const rect = bar.getBoundingClientRect();
    v.currentTime = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * v.duration;
  };

  const showControls = () => {
    setShowCtrl(true);
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setShowCtrl(false), 2500);
  };

  const effectiveVolume = muted ? 0 : volume;

  const VolumeIcon = () => {
    if (muted || effectiveVolume === 0) return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 18l2 2L21 18.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
      </svg>
    );
    if (effectiveVolume < 0.5) return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>
      </svg>
    );
    return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
      </svg>
    );
  };

  /* Image mode */
  if (isImage) {
    return (
      <div ref={wrapRef} className="sm-cvid">
        <img src={src} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", background: "#000" }} />
      </div>
    );
  }

  /* Video mode */
  return (
    <div
      ref={wrapRef}
      className="sm-cvid"
      onMouseMove={showControls}
      onMouseEnter={showControls}
      onMouseLeave={() => { clearTimeout(hideTimer.current); setShowCtrl(false); }}
      onClick={togglePlay}
    >
      <video
        ref={videoRef}
        src={src}
        muted={muted}
        playsInline
        loop={false}
        onTimeUpdate={() => { const v = videoRef.current; if (v?.duration) setProgress(v.currentTime / v.duration); }}
        onLoadedMetadata={() => { if (videoRef.current) setDuration(videoRef.current.duration); }}
        onPlay={() => { setPlaying(true); setShowThumb(false); }}
        onPause={() => setPlaying(false)}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        style={{ width: "100%", height: "100%", objectFit: isFS ? "contain" : "fill", display: "block", background: "#000" }}
      />

      {thumb && (
        <div className={`sm-cvid-thumb-overlay${showThumb ? " sm-cvid-thumb-overlay--visible" : ""}`}>
          <img src={thumb} alt="" />
        </div>
      )}

      {!playing && (
        <div className="sm-cvid-play-overlay" onClick={togglePlay}>
          <svg viewBox="0 0 80 80" fill="none" width="52" height="52">
            <circle cx="40" cy="40" r="40" fill="rgba(0,0,0,0.45)" />
            <polygon points="32,24 60,40 32,56" fill="white" />
          </svg>
        </div>
      )}

      <div className={`sm-cvid-ctrl${showCtrl ? " sm-cvid-ctrl--show" : ""}`}>

        <button className="sm-cvid-playbtn" onClick={togglePlay}>
          {playing
            ? <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><rect x="5" y="3" width="4" height="18" rx="1"/><rect x="15" y="3" width="4" height="18" rx="1"/></svg>
            : <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><polygon points="5,3 19,12 5,21"/></svg>
          }
        </button>

        <span className="sm-cvid-time">{fmt(progress * duration)}</span>

        <div ref={progressRef} className="sm-cvid-bar" onClick={handleSeek}>
          <div className="sm-cvid-bar-fill" style={{ width: `${progress * 100}%` }} />
          <div className="sm-cvid-bar-thumb" style={{ left: `${progress * 100}%` }} />
        </div>

        <span className="sm-cvid-time">{fmt(duration)}</span>

        <div className="sm-cvid-vol-group" onClick={(e) => e.stopPropagation()}>
          <button className="sm-cvid-playbtn" onClick={toggleMute} aria-label={muted ? "Unmute" : "Mute"}>
            <VolumeIcon />
          </button>
          <input
            className="sm-cvid-vol-slider"
            style={{ "--vol": effectiveVolume }}
            type="range"
            min="0" max="1" step="0.02"
            value={effectiveVolume}
            onChange={handleVolume}
            aria-label="Volume"
          />
        </div>

        <button className="sm-cvid-playbtn" onClick={toggleFS}>
          {isFS
            ? <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
            : <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
          }
        </button>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   INNER SLIDER — arrow nav within a panel's array
   Auto-slides every 2 s; pauses on hover
══════════════════════════════════════════════ */
function InnerSliderSM({ srcs, thumb, videoRef }) {
  const [idx, setIdx]   = useState(0);
  const hoveredRef      = useRef(false);
  const timerRef        = useRef(null);

  useEffect(() => { setIdx(0); }, [srcs]);

  const count = srcs.length;
  const prev  = (e) => { e.stopPropagation(); setIdx((i) => (i - 1 + count) % count); };
  const next  = (e) => { e.stopPropagation(); setIdx((i) => (i + 1) % count); };

  useEffect(() => {
    if (count <= 1) return;
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      if (!hoveredRef.current) {
        setIdx((i) => (i + 1) % count);
      }
    }, 2000);
    return () => clearInterval(timerRef.current);
  }, [count]);

  const handleMouseEnter = () => { hoveredRef.current = true; };
  const handleMouseLeave = () => { hoveredRef.current = false; };

  if (count === 0) return null;

  return (
    <div
      className="sm-inner-slider"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {srcs.map((src, i) => (
        <div key={i} className={`sm-inner-layer${i === idx ? " sm-inner-layer--active" : ""}`}>
          <VideoPlayerSM
            src={src}
            thumb={i === 0 && !isImageSrcSM(src) ? thumb : undefined}
            videoRef={i === idx ? videoRef : undefined}
          />
        </div>
      ))}

      {count > 1 && (
        <>
          <button className="sm-inner-arrow sm-inner-arrow--prev" onClick={prev} aria-label="Previous">
            <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
              <polyline points="15,6 9,12 15,18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className="sm-inner-arrow sm-inner-arrow--next" onClick={next} aria-label="Next">
            <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
              <polyline points="9,6 15,12 9,18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="sm-inner-dots">
            {srcs.map((_, i) => (
              <button
                key={i}
                className={`sm-inner-dot${i === idx ? " sm-inner-dot--active" : ""}`}
                onClick={(e) => { e.stopPropagation(); setIdx(i); }}
                aria-label={`Item ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════
   VIDEO SLIDER SOCIAL MEDIA
══════════════════════════════════════════════ */
function VideoSliderSM({ slides }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [panelIdx,    setPanelIdx]    = useState(0);

  const mainRefs   = useRef([]);
  const behindRefs = useRef([]);
  if (mainRefs.current.length !== slides.length) {
    mainRefs.current   = slides.map((_, i) => mainRefs.current[i]   ?? React.createRef());
    behindRefs.current = slides.map((_, i) => behindRefs.current[i] ?? React.createRef());
  }

  const pauseAll = useCallback((exceptIdx) => {
    slides.forEach((_, i) => {
      if (i === exceptIdx) return;
      [mainRefs.current[i], behindRefs.current[i]].forEach((r) => {
        if (r?.current?.pause) { r.current.pause(); r.current.currentTime = 0; }
      });
    });
  }, [slides]);

  const handleThumbClick = (i) => {
    if (i === activeSlide) return;
    [mainRefs.current[activeSlide], behindRefs.current[activeSlide]].forEach((r) => {
      if (r?.current?.pause) { r.current.pause(); r.current.currentTime = 0; }
    });
    setActiveSlide(i);
    setPanelIdx(0);
    pauseAll(i);
  };

  const currentSlide = slides[activeSlide];
  const leftSrcs   = Array.isArray(currentSlide?.left)   ? currentSlide.left   : (currentSlide?.left   ? [currentSlide.left]   : []);
  const behindSrcs = Array.isArray(currentSlide?.behind) ? currentSlide.behind : (currentSlide?.behind ? [currentSlide.behind] : []);
  const hasBehind  = behindSrcs.length > 0;

  return (
    <div className="sm-vslider-wrap">
      <div className="sm-vslider">

        <div className="sm-vslider-left-wrap">
          <div className="sm-vslider-left">

            {/* Per-slide label — overlay pill, top-left of the panel */}
            {currentSlide?.sub && (
              <div className="sm-sub-pill">{currentSlide.sub}</div>
            )}

            <div className={`sm-vslider-vid-layer${panelIdx === 0 ? " sm-vslider-vid-layer--active" : ""}`}>
              <InnerSliderSM srcs={leftSrcs} thumb={currentSlide?.thumb} videoRef={mainRefs.current[activeSlide]} />
            </div>

            {hasBehind && (
              <div className={`sm-vslider-vid-layer${panelIdx === 1 ? " sm-vslider-vid-layer--active" : ""}`}>
                <InnerSliderSM srcs={behindSrcs} thumb={currentSlide?.thumb} videoRef={behindRefs.current[activeSlide]} />
              </div>
            )}

          </div>

          {hasBehind && (
            <div className="sm-vslider-dots">
              <button className={`sm-vslider-dot${panelIdx === 0 ? " sm-vslider-dot--active" : ""}`} onClick={() => setPanelIdx(0)} aria-label="Main view" />
              <button className={`sm-vslider-dot${panelIdx === 1 ? " sm-vslider-dot--active" : ""}`} onClick={() => setPanelIdx(1)} aria-label="Alternate view" />
            </div>
          )}
        </div>

        <div className="sm-thumb-stack">
          {slides.map((slide, i) => (
            <button
              key={i}
              className={`sm-thumb-stack-item${activeSlide === i ? " sm-thumb-stack-item--active" : ""}`}
              onClick={() => handleThumbClick(i)}
            >
              <img src={slide.thumb} alt={slide.sub} />
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   SECTION SOCIAL MEDIA NEW
══════════════════════════════════════════════ */
export default function SectionDigitalMarketingNew() {
  const [activeFilter, setActiveFilter] = useState(null);

  const visibleSlides = useMemo(() => {
    if (!activeFilter) return ALL_SLIDES_SM;
    return ALL_SLIDES_SM.filter((s) => s.industry === activeFilter);
  }, [activeFilter]);

  const handleFilter = (industry) => {
    setActiveFilter((prev) => (prev === industry ? null : industry));
  };

  return (
    <section className="g-section g-section--white sm-section-decor">
      <div className="g-container">

        <div className="sm-hdr">
          <div className="sm-hdr-left">
            <h2 className="sm-title">Digital Marketing</h2>
            <p className="sm-desc">
              Extending communication across digital channels to improve
              visibility, audience engagement, and business reach.
            </p>
          </div>

          <div className="sm-filter-bar">
            {INDUSTRIES_SM.map((ind) => (
              <button
                key={ind}
                className={`sm-filter-btn${activeFilter === ind ? " sm-filter-btn--active" : ""}`}
                onClick={() => handleFilter(ind)}
              >
                {ind}
              </button>
            ))}
            <button
              className={`sm-filter-clear${activeFilter ? " sm-filter-clear--visible" : ""}`}
              onClick={() => setActiveFilter(null)}
              aria-label="Clear filter"
              tabIndex={activeFilter ? 0 : -1}
            >
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
                <line x1="20" y1="4" x2="4"  y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="sm-body">
          {visibleSlides.length > 0 ? (
            <VideoSliderSM
              key={activeFilter ?? "all"}
              slides={visibleSlides}
            />
          ) : (
            <div className="sm-empty">No items found for this industry.</div>
          )}
        </div>

        <p className="sm-bottom-desc">
          Supporting businesses through structured campaigns, content-driven
          communication, and measurable marketing outcomes.
        </p>

      </div>
    </section>
  );
}